import { RowHeightHelper } from "app/helpers/rowHeightHelper";
import type { CompetitionType } from "app/types/competitionType";
import React, { Component } from "react";
import { VariableSizeList as List } from "react-window";
import CompetitionCell from "../../../../../EventsScreen/components/CompetitionCell/CompetitionCell";
type Props = {
  utilizeWindowList: any;
  list: any;
  showUnsummarizedMarketsModal: boolean;
  competitionList: CompetitionType[];
  rowRenderer: (...args: Array<any>) => any;
  resizeCell: (...args: Array<any>) => any;
  setCompetitionWithFavouritesList: (...args: Array<any>) => any;
  line: string;
  eventHasGoneLive: (...args: Array<any>) => any;
};

class RenderCompetitionList extends Component<Props> {
  calculateListHeight: () => number = () => {
    let height = 1000;

    if (window.innerHeight > 200) {
      height = window.innerHeight - 165;
    }

    return height;
  };

  render():
    | React.ReactElement<React.ComponentProps<any>, any>
    | Array<null | React.ReactElement<React.ComponentProps<any>, any>> {
    const {
      utilizeWindowList,
      list,
      showUnsummarizedMarketsModal,
      competitionList,
      rowRenderer,
      resizeCell,
      setCompetitionWithFavouritesList,
      line,
      eventHasGoneLive,
    } = this.props;

    // Render the list using react-window if it's above a certain length
    // So the app doesn't reach the dom node limit and crash
    if (utilizeWindowList) {
      return (
        <List
          ref={list}
          className={`List ${
            showUnsummarizedMarketsModal === true ? "suspended" : ""
          }`}
          itemCount={competitionList.length + 1}
          height={this.calculateListHeight()}
          itemSize={RowHeightHelper.calculateAsianRowHeight}
          itemData={competitionList}
        >
          {rowRenderer}
        </List>
      );
    } else {
      return competitionList.map(competition => {
        if (!competition.events.length) return null;
        return (
          <CompetitionCell
            data={competition}
            competitionIndex={competition.id}
            resizeCell={resizeCell}
            key={
              "rcl_" +
              competition.id +
              (competition.live ? "_live" : "_deadball")
            }
            setCompetitionWithFavouritesList={setCompetitionWithFavouritesList}
            line={line}
            eventHasGoneLive={eventHasGoneLive}
            listSize={competitionList.length}
          />
        );
      });
    }
  }
}

export default RenderCompetitionList;
